<mat-toolbar class="mat-elevation-z8">
  {{ 'USER_MANAGEMENT.EDIT_USER' | transloco }} - {{ data.user?.email }}
</mat-toolbar>

@if (isLoading) {
  <div class="spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<div></div>

<mat-dialog-content class="mt-3">
  <form [formGroup]="editUserForm">
    <!-- Email -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>
        {{ 'USER_MANAGEMENT.EMAIL' | transloco }}
      </mat-label>
      <input matInput [placeholder]="'USER_MANAGEMENT.EMAIL' | transloco" formControlName="email">
      <mat-icon matSuffix>email</mat-icon>
      @if (editUserForm.get('email')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.EMAIL' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <!-- First Name -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>
        {{ 'USER_MANAGEMENT.FIRSTNAME' | transloco }}
      </mat-label>
      <input matInput [placeholder]="'USER_MANAGEMENT.FIRSTNAME' | transloco" formControlName="firstname">
      <mat-icon matSuffix>person</mat-icon>
      @if (editUserForm.get('firstname')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.FIRSTNAME' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <!-- Last Name -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label> {{ 'USER_MANAGEMENT.LASTNAME' | transloco }}
      </mat-label>
      <input matInput formControlName="lastname">
      <mat-icon matSuffix>person</mat-icon>
      @if (editUserForm.get('lastname')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.LASTNAME' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>

    <!-- <div style="margin-left: 0.5rem; margin-bottom: 0.75rem;">{{ 'USER_MANAGEMENT.CELLPHONE' | transloco }}</div> -->
    <mat-form-field appearance="outline" class="mb-2 w-100">
      <mat-label>{{ 'USER_MANAGEMENT.CELLPHONE' | transloco }}</mat-label>
      <input matInput type="tel" [placeholder]="'USER_MANAGEMENT.CELLPHONE' | transloco" formControlName="mobile">
      <mat-icon matSuffix>phone</mat-icon>
      @if (editUserForm.get('mobile')?.hasError('required')) {
        <mat-error>
          {{ 'FORM.VALIDATION.REQUIRED' | transloco: { field: ('USER_MANAGEMENT.CELLPHONE' | transloco) } }}
        </mat-error>
      }
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>{{ 'LOGIN.LANGUAGE' | transloco }}</mat-label>
      <mat-select formControlName="defaultLanguage">
        @for (lang of languages; track lang) {
          <mat-option [value]="lang.value">
            {{ lang.viewValue }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- SMS Verification -->
    <div class="mb-3">
      <mat-checkbox formControlName="smsVerification">
        {{ 'USER_MANAGEMENT.SMS_VERIFICATION' | transloco }}
      </mat-checkbox>
    </div>

    <div class="label-margin-left-bottom">
      {{ 'USER_MANAGEMENT.MEMBERSHIP_TYPE' | transloco }}
    </div>
    @if (enumEntries?.length > 0) {
      <div formArrayName="memberTypes" class="mb-2 flex flex-col gap-2">
        @for (entry of enumEntries; track entry; let i = $index) {
          <mat-checkbox [formControlName]="i">
            {{ entry[2] | transloco }}
          </mat-checkbox>
        }
      </div>
    }
  </form>

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" [align]="'end'">
  @if (data.user?.hasDeviceToken) {
    <button mat-raised-button type="button"
      (click)="openNotificationForm($safeNavigationMigration(data.user?.userId))">
      <mat-icon>notifications</mat-icon>
      <span class="button-content">
        {{'ORDER_DETAILS.BUTTONS.MOBILE_NOTIFICATION' | transloco}}
      </span>
    </button>
  }
  @if (data.user?.email) {
    <button mat-raised-button type="button" (click)="openForgotPassword($safeNavigationMigration(data?.user?.email))">
      {{ 'USER_MANAGEMENT.RESET_PASSWORD' | transloco }}
      <mat-icon>lock_reset</mat-icon>
    </button>
  }
  <button mat-raised-button color="warn" type="button" (click)="openConfirmDelete()">
    <mat-icon>delete</mat-icon>
    <span class="button-content">
      {{'USER_MANAGEMENT.DELETE_USER' | transloco}}
    </span>
  </button>
  <button mat-raised-button color="primary" (click)="submitForm()">
    <span>
      {{'PRICING.FORM.EDIT' | transloco }}
    </span>
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>
